import type { ReactNode, Ref } from 'react'
import { ScrollArea } from '@/components/ui/scroll-area'
import { Scrollbar } from '@/components/ui/scrollbar'
import { cn } from '@/helpers/utils'

interface HorizontalScrollerProps {
	/** The widthy track to scroll (e.g. a `flex w-max` row). */
	children: ReactNode
	/** Extra classes on the scroll root. */
	className?: string
	/** Exposes the scroll viewport, e.g. to auto-center an active item. */
	viewportRef?: Ref<HTMLDivElement>
	/** Show the thin scrollbar instead of hiding it (hidden by default). */
	showScrollbar?: boolean
}

/**
 * Horizontal overflow container: content wider than the viewport scrolls
 * sideways (touch / drag / wheel), with the scrollbar hidden by default. The
 * child must be the widthy track (e.g. `flex w-max`). Extracts the shared
 * ScrollArea + Scrollbar wiring reused by the marquee tab bars and stat rows.
 */
export function HorizontalScroller({
	children,
	className,
	viewportRef,
	showScrollbar = false
}: HorizontalScrollerProps) {
	return (
		<ScrollArea
			className={cn('min-w-0', className)}
			scrollbar={
				<Scrollbar
					className={cn(
						!showScrollbar && 'data-[orientation=horizontal]:h-0'
					)}
					orientation='horizontal'
				/>
			}
			viewportProps={viewportRef ? { ref: viewportRef } : undefined}
		>
			{children}
		</ScrollArea>
	)
}
